<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="vol-1-dedication">
<div class="text" id="vol-1-dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">TO</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">DR. JOHN F. WILKINSON</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">with happy memories of</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">the lovely land of</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">France</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol-001-dedication.vue?0c505722